import { MsalProvider } from "@azure/msal-react";
import CssBaseline from '@mui/material/CssBaseline';
import { ThemeProvider } from '@mui/material/styles';
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { BrowserRouter, Route, Switch, } from "react-router-dom";
import GlobalLoader from "./components/loader/GlobalLoader";
import ProgressLoader from "./components/loader/progressLoader";
import CustomSnackbar from './components/snackbar/CustomSnackbar';
import Login from './pages/login';
import InitialOnboard from "./pages/onBoard";
import PaleteView from './pages/paletteViewer';
import { toggleTheme } from "./redux/actions/commonAction";
import PrivateRoute from "./routers/privateRoute";
import AppRouters from './routers/routers';
import themeConfig from './themes/theme';
import storage from "./utils/storage";

const App = ({ pca }) => {
  const dispatch = useDispatch()
  const { themeType, globalLoader, showProgressBar } = useSelector(state => state.common)

  useEffect(() => {
    const defaultTheme = storage.getItem('themeType')
    if (defaultTheme) {
      dispatch(toggleTheme(defaultTheme))
    }
    else {
      const darkModeMediaQuery = window.matchMedia('(prefers-color-scheme: dark)');
      dispatch(toggleTheme(darkModeMediaQuery.matches ? "dark" : "light"))
    }
    //eslint-disable-next-line
  }, []);

  return (
    <MsalProvider instance={pca}>
      <ThemeProvider theme={themeConfig(themeType)}>
        <CssBaseline />
        <BrowserRouter>
          <Switch>
            <Route exact path="/login" component={Login} />
            <Route exact path="/theme" component={PaleteView} />
            <Route exact path="/intial-onboarding" component={InitialOnboard} />
            <PrivateRoute path="/" component={AppRouters} />
          </Switch>
        </BrowserRouter>
        <CustomSnackbar />
        <GlobalLoader open={globalLoader} />
        <ProgressLoader open={showProgressBar} />
      </ThemeProvider >
    </MsalProvider>
  );
}

export default App;
